import { cn } from '@/lib/utils';

const statusConfig: Record<string, { text: string; bg: string; border?: string }> = {
  draft:          { text: '#6B7280', bg: '#F3F4F6', border: '#E5E7EB' },
  active:         { text: '#059669', bg: '#D1FAE5' },
  completed:      { text: '#059669', bg: '#D1FAE5' },
  cancelled:      { text: '#6B7280', bg: '#F3F4F6', border: '#E5E7EB' },
  on_time:        { text: '#059669', bg: '#D1FAE5' },
  completed_late: { text: '#DC2626', bg: '#FEE2E2' },
  late:           { text: '#DC2626', bg: '#FEE2E2' },
  planning:       { text: '#6366F1', bg: '#E0E7FF' },
  live:           { text: '#059669', bg: '#D1FAE5' },
  not_started:    { text: '#6B7280', bg: '#F3F4F6', border: '#E5E7EB' },
  in_progress:    { text: '#2563EB', bg: '#DBEAFE' },
  done:           { text: '#059669', bg: '#D1FAE5' },
  pending:        { text: '#F59E0B', bg: '#FEF3C7' },
  approved:       { text: '#059669', bg: '#D1FAE5' },
  blocked:        { text: '#DC2626', bg: '#FEE2E2' },
};

function formatLabel(status: string) {
  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.draft!;
  return (
    <span
      className={cn('inline-flex items-center rounded px-2 py-0.5 text-xs font-medium', className)}
      style={{
        color: config.text,
        backgroundColor: config.bg,
        border: config.border ? `1px solid ${config.border}` : undefined,
      }}
    >
      {formatLabel(status)}
    </span>
  );
}
